/**
 * Created by Kristy on 19/12/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sectorsPharmacyAssignations', {
                parent: 'pharmacyAssignations',
                url: '/sectors',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR']
                },
                templateUrl: 'app/displays/pharmacyAssignations/sectors/sectors.html',
                controller: 'SectorsAssignationsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
